import { Toast } from 'mand-mobile'
import { clearSessionSignKey } from '@/utils/request-signature.mjs'
const tokenKey = 'FLP-USER-TOKEN'
class Global {
  randomString (e) {
    e = e || 32
    const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    const a = t.length
    let n = ''
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
    return n
  }

  setCookie (name = tokenKey, value, day) {
    if (name === tokenKey) clearSessionSignKey()
    if (day && day !== 0) {
      const expires = day * 24 * 60 * 60 * 1000
      const date = new Date(+new Date() + expires)
      document.cookie = name + '=' + `${this.randomString(7) + escape(value)}` + ';expires=' + date.toUTCString()
    } else {
      document.cookie = name + '=' + `${this.randomString(7) + escape(value)}`
    }
  }

  getCookie (name = tokenKey) {
    const arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
    if (arr != null) {
      return unescape(arr[2])
    }
    return null
  }

  removeCookie (name = tokenKey) {
    if (name === tokenKey) clearSessionSignKey()
    const exp = new Date()
    exp.setTime(exp.getTime() - 1)
    const cval = this.getCookie(name)
    if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
  }

  // 获取location中查询参数
  getLocationQueryParam (key, type = 'hash') {
    let value = ''
    const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`)

    if (type === 'search') {
      value = window.location.search
        .replace('&amp;', '&')
        .substring(1)
        .match(reg)
    } else if (type === 'hash') {
      const { hash } = window.location
      const index = hash.indexOf('?')
      if (index === -1) {
        value = null
      } else {
        value = hash
          .replace('&amp;', '&')
          .substring(index + 1)
          .match(reg)
      }
    }
    return value === null ? null : unescape(value[2])
  }

  // 客户端语言
  browserLocale () {
    let lang = 'en'
    if (this.getCookie('Accept-Language')) {
      lang = this.getCookie('Accept-Language') || 'en'
    } else {
      lang = this.getLocalStorage('user-locale') || 'en'
    }
    if (lang) {
      lang = lang.substring(0, 2)
    }
    return lang
  }

  // 获取webview的session_id
  getSidToken () {
    let token = this.getCookie('FLE-SESSION-ID')
    // IOS写法
    if (token) {
      return token
    } else {
      token = this.getCookie('fle-session-id') || '1615518773_44cef6c571d9d7c8d3ff9953a73b0fe3ea68b9e3e6151be0ffa5ef3d1e71a024_AA0316' // 安卓写法
      // 1554977381_c33b88b82e6e10fa2abb3166734cc39c261af1d92b9fbd1df4785bc16009d29c_17359
      // 1554970623_17b1e33f404b79c146b7c5d8fe1f1d9d75f42b6711aaa4797d946fe34fe0be7e_20441
      return token
    }
  }

  // 获取 localStorage
  getLocalStorage (key) {
    const value = localStorage.getItem(key)
    return value
  }

  // 设置 localStorage
  setLocalStorage (name, value) {
    localStorage.setItem(name, value)
  }

  // 重复登录处理
  setLoginErrorHandle (code, errorMessage) {
    if (window.webkit && window.webkit.messageHandlers) { // 在IOS环境下
      window.webkit.messageHandlers.fle_walletNetErrory.postMessage({ code, errorMessage })
    }
    if (window.FLEJSBridge) { // Android环境下
      window.FLEJSBridge.fle_walletNetErrory(code, errorMessage)
    }
  }

  // 身份证照片
  setIDCard (init, cd) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fle_walletImg) {
      window.webkit.messageHandlers.fle_walletImg.postMessage(init)
      window.on_fle_walletImg_success = (fileString) => { // 点击拍照功能的确认回调
        cd('', { files: [this.dataURLtoFile(fileString)] })
      }
      window.on_fle_walletImg_error = (message) => { // 点击拍照功能的取消回调
        // Toast.failed(message)
      }
    } else if (window.FLEJSBridge && window.FLEJSBridge.fle_walletImg) {
      window.FLEJSBridge.fle_walletImg(init)
      window.on_fle_walletImg_success = (fileString) => { // 点击拍照功能的确认回调
        cd('', { files: [this.dataURLtoFile(fileString)] })
      }
      window.on_fle_walletImg_error = (message) => { // 点击拍照功能的取消回调
        // Toast.failed(message)
      }
    }
  }

  // 身份证Base64 地址 转成文件流
  dataURLtoFile (dataUrl, fileName = '') {
    const bstr = atob(dataUrl)
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], fileName)
  }

  // 活体方法
  onWalletBiopsy (token, url, cd) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fle_walletBiopsy) { // 调取ios活体方法
      window.webkit.messageHandlers.fle_walletBiopsy.postMessage({ token, url }) // HACK 需要给客户端传递参数 为了调取旷世的SDK
      // 点击活体确认回调
      window.on_fle_walletBiopsy_success = (fileString) => {
        const { token, data } = JSON.parse(fileString)
        // 活体验证成功后进入下一步
        cd(token, data)
      }
      // 点击活体取消回调
      window.on_fle_walletBiopsy_error = (message) => { // 点击录像的取消回调
        Toast.failed(message)
      }
    } else if (window.FLEJSBridge && window.FLEJSBridge.fle_walletBiopsy) { // 调取Android活体方法
      window.FLEJSBridge.fle_walletBiopsy(token, url) // HACK 需要给客户端传递参数 为了调取旷世的SDK
      // 点击活体确认回调
      window.on_fle_walletBiopsy_success = (fileString) => {
        const { token, data } = JSON.parse(fileString)
        // 活体验证成功后进入下一步
        cd(token, data)
      }
      window.on_fle_walletBiopsy_error = (message) => { // 点击录像的取消回调
        Toast.failed(message)
      }
    }
  }
}

export default new Global()
